module.exports = __webpack_public_path__ + "static/media/exit.660ed3b5.svg";